import request from '@/utils/request';

export function getSysBannerList(query) {
  return request({
    url: '/api/system/sysBanner/querySysBannerList',
    method: 'post',
    data: query
  });
}



// WEBPACK FOOTER //
// ./src/api/banner/index.js